// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"formdata__list--3hmqf","title":"formdata__title--3CsGc","data":"formdata__data--vYLsQ","nowrap":"formdata__nowrap--3V7GN"};